export default {
      id: "logo_viroflay-usage",
      viewBox: "0 0 100 120",
      url: "../dist/images/" + "sprite.svg#logo_viroflay-usage",
      toString: function () {
        return this.url;
      }
    }